import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../contexts/AuthContext";

export default function MobileConnectPage() {
  const { user, loading } = useAuth();
  const location = useLocation();
  const flow = new URLSearchParams(location.search).get("flow") || sessionStorage.getItem("astrofate_mobile_flow") || "";
  const valid = /^[A-Za-z0-9_-]{43}$/.test(flow);
  const [status, setStatus] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (valid) sessionStorage.setItem("astrofate_mobile_flow", flow); }, [valid, flow]);
  const approve = async () => {
    setBusy(true);
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/mobile/auth/approve`, { flow_id: flow }, { withCredentials: true });
      sessionStorage.removeItem("astrofate_mobile_flow");
      setStatus("Connected. Return to the AstroFate Android app.");
    } catch (e) { setStatus(e.response?.data?.detail || "Unable to connect. Please start again in the app."); }
    finally { setBusy(false); }
  };
  return <main style={{ minHeight: "80vh", padding: "120px 20px 80px", maxWidth: 620, margin: "auto" }}>
    <h1 className="font-cinzel" style={{ color: "#FFD166", fontSize: 28 }}>Connect AstroFate Android</h1>
    <p data-testid="mobile-connect-explanation" style={{ margin: "24px 0", color: "#E2D8F0" }}>Approve only if you just requested sign-in from your Android app. It will use your existing AstroFate account and saved data.</p>
    {!valid ? <p role="alert" data-testid="mobile-connect-invalid">Invalid connection. Start again in the Android app.</p> : loading ? <p data-testid="mobile-connect-loading">Loading account…</p> : !user ?
      <Link data-testid="mobile-connect-login" className="btn-gold" to={`/auth?tab=login&redirect=${encodeURIComponent(`/mobile/connect?flow=${flow}`)}`}>Sign in to continue</Link> : <>
        <p data-testid="mobile-connect-account" style={{ overflowWrap: "anywhere", marginBottom: 20 }}>{user.email}</p>
        {!status && <button data-testid="mobile-connect-approve" className="btn-gold" disabled={busy} onClick={approve}>{busy ? "Connecting…" : "Approve Android sign-in"}</button>}
      </>}
    {status && <p role="status" data-testid="mobile-connect-status" style={{ marginTop: 24 }}>{status}</p>}
  </main>;
}